document.addEventListener('DOMContentLoaded', function() {
  
  const fixCookieButton = setInterval(function() {
    
    const theButton = document.querySelector('button[aria-controls="pandectes-banner"]');
    
    if (theButton) {
      const problematicParent = theButton.closest('div[aria-hidden="true"]');
      
      if (problematicParent) {
        problematicParent.removeAttribute('aria-hidden');
        
        clearInterval(fixCookieButton);
        
      } else {
        clearInterval(fixCookieButton);
      }
    }
  }, 500);

  setTimeout(function() {
    clearInterval(fixCookieButton);
  }, 10000);
  
});